
import React, {Component} from 'react'
import CategoryTreeSelect from "../containers/CategoryTreeSelect";
import _ from 'lodash';
import { message } from 'antd'

class ProductsBatch extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedCategories: []
        }

        this.onClickRightButton = this.onClickRightButton.bind(this);
        this.onTextViewChange = this.onTextViewChange.bind(this);
    }

    componentDidMount() {
    }

    onClickRightButton() {
        this.props.saveProductsCategory();
    }

    onTextViewChange(e) {
        const contents = _.split(e.target.value, '\n');
        this.props.onTextViewChange(contents);
    }
    
    categoryTreeSelection = (value, children) => {
        if(children.length >= 1) {
            return message.error("只能选中三级类目！");
        }
        if(value.length > 1) {
            return message.error("只能选中一个类目！");
        }
        this.setState({
            selectedCategories: value,
        });
        this.props.onCategoryInputChange(value)
    }

    render() {
        let {selectedCategories} = this.state
        return (
            <div className='container'>
                
                <div className='mt-3'>
                    <h3>{this.props.title}</h3>
                    <textarea className="text-view"
                        name=""
                        id=""
                        cols='88'
                        rows="10"
                        onChange={ this.onTextViewChange }>
                    </textarea>
                </div>
                <div className="input-group mt-3 col-md-8"
                    style={{display: 'flex', flexWrap: 'nowrap'}}>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center'
                    }}>
                        <h6>Category:</h6>
                    </div>
                    <CategoryTreeSelect
                        selectedCategories={selectedCategories}
                        onChange={this.categoryTreeSelection}
                        deprecateOldCategories={true}
                    />
                   
                    <div className="input-group-append">
                        <button
                            className="btn btn-info"
                            type="button"
                            onClick={ this.onClickRightButton }>Save</button>
                    </div>
                </div>
            </div>
        );
    }
}

export default ProductsBatch;